import React from 'react'

import useWindowDimensions from '../hooks/WindowDimentsions'

import AccountMenu from '../component/AccountMenu'

import { ToastContainer, toast } from 'react-toastify';
import {userLogout} from "../featuers/auth/authActions";
import { useDispatch, useSelector } from 'react-redux'
import Tooltip from '@mui/material/Tooltip';
import { useNavigate } from 'react-router-dom';

export default function NavBar(){

// =================================================================
// =================================================================
// =================================================================
// 1-  hooks calling (important!! : state managment useSelector )

const {width , height } = useWindowDimensions()
const dispatch = useDispatch()

const navigate = useNavigate()




// =================================================================
// =================================================================
// =================================================================
// 2-  useStates and variable declaration

const [collapsed , Setcollapsed] = React.useState(
    document.getElementById('navbarTogglerDemo02')?.classList.contains('show')
)

const state_auth  = useSelector((state) => state.auth)



// =================================================================
// =================================================================
// =================================================================
// 3-  use effects



// =================================================================
// =================================================================
// =================================================================
// 4-  conditions (rendering)


// =================================================================
// =================================================================
// =================================================================
// 5-  data processing functions


    function showNav(){
        Setcollapsed(e => !e)
    }
    function searchfocus() {
        const nav = document.getElementById('navbarTogglerDemo02');
        const input = document.querySelector('.search_input');
        if (nav && !nav.classList.contains('show')) {
            nav.classList.add('show');
            Setcollapsed(true);
        }
        if (input) {
            input.focus();
        }
    }

    return(
        <>
            {/* <div className='signin_up_offer_area'>
                <div className='sign_offer_container position-relative container h-100 justify-content-center d-flex align-items-center'>
                    <div className='offer_text'>

                        Sign up and get 20% off to your first order.
                        <a className='offer_link'>
                            Sign Up Now
                        </a>
                    </div>
                    {width > 576 &&
                        <button className='close_btn position-absolute pe-3 pe-sm-0' style={{right:"0"}}><i class="fa-solid fa-x"></i></button>
                    }
                </div>
            </div> */}
            <div className="nav_container container">
                <nav className="navbar navbar-expand-lg">
                    <div className="container-fluid" style={{paddingLeft:"0" , paddingRight:"0"}}>
                        {
                            width < 992 && 
                            <>
                            <button className="navbar-toggler" onClick={showNav}  type="button" data-bs-toggle="collapse" data-bs-target="#navbarTogglerDemo02" aria-controls="navbarTogglerDemo02" aria-expanded="false" aria-label="Toggle navigation">
                                { !collapsed ? 
                                    <i class="fa-solid fa-bars bars_default"></i>                                
                                    :
                                    <i className="fa-solid fa-bars-staggered bars_staggered" ></i>
                                }
                            </button>
                            <a className="navbar-brand" href="/">SHOP.CO</a>
                            </>
                        }
                        {
                            width > 992 &&
                            <>
                            <a className="navbar-brand" href="/">SHOP.CO</a>
                            <button className="navbar-toggler" type="button" data-bs-toggle="collapse" data-bs-target="#navbarTogglerDemo02" aria-controls="navbarTogglerDemo02" aria-expanded="false" aria-label="Toggle navigation">
                                
                                <span className="navbar-toggler-icon"></span>
                                
                            </button>
                            </>
                        }

                        { width < 992  && 
                                <div className='nav_btns'>
                                    <i className="fa fa-search" onClick={searchfocus}></i>
                                    <Tooltip title ="Cart">
                                        <i className="fa-solid fa-cart-shopping" onClick={() => navigate("/cart/")}></i>
                                    </Tooltip>

                                    {( Object.keys(state_auth.user_info).length !== 0) ?
                                        <AccountMenu /> 
                                        :
                                        <Tooltip title="Sign In">

                                            <i className="fa-regular fa-circle-user" onClick={()=> navigate("/auth/signin/")}></i> 
                                        </Tooltip>
                                    }
                                </div>
                        }
        
                            <div className="collapse navbar-collapse " id="navbarTogglerDemo02">
                                <div className='d-flex align-items-center nav-cont2 justify-content-between' style={{ width: '100%' }}>
                                <ul className="navbar-nav  mb-2 mb-lg-0 ">
                                    <li class="nav-item dropdown">
                                        <a class="nav-link dropdown-toggle" href="#" role="button" data-bs-toggle="dropdown" aria-expanded="false">
                                            Shop
                                        </a>
                                        <ul class="dropdown-menu">
                                            <li><a class="dropdown-item" href="/shop/gym">Gym</a></li>
                                            <li><a class="dropdown-item" href="/shop/party">Party</a></li>
                                            <li><a class="dropdown-item" href="/shop/formal">Formal</a></li>
                                            <li><a class="dropdown-item" href="/shop/casual">Casual</a></li>
                                        </ul>
                                        </li>
                                    <li className="nav-item">
                                        <a className="nav-link" href="/#new_arrivals">New Arrivals</a>
                                    </li>
                                    <li className="nav-item">
                                        <a className="nav-link" href="/#top_selling">Top Selling</a>
                                    </li>
                                    <li className="nav-item">
                                        <a className="nav-link" href="/#category">Brands</a>
                                    </li>

                                </ul>
                                <form className="d-flex" role="search">
                                    <div className='search_container' style={{ position: 'relative' }}>
                                        <span className="search_icon">
                                            <i className="fa fa-search"></i>
                                        </span>
                                        <input
                                            className="form-control me-2 search_input"
                                            type="search"
                                            placeholder="Search for products..."
                                            aria-label="Search"
                                            
                                        />
                                    </div>
                                    {
                                        width>992 &&
                                    <div className='nav_btns d-flex align-items-center'>
                                        <Tooltip title ="Cart">
                                        <i className="fa-solid fa-cart-shopping" onClick={() => navigate("/cart/")}></i>
                                    </Tooltip>

                                    {( Object.keys(state_auth.user_info).length !== 0) ?
                                        <AccountMenu /> 
                                        :
                                        <Tooltip title="Sign In">

                                            <i className="fa-regular fa-circle-user" onClick={()=> navigate("/auth/signin/")}></i> 
                                        </Tooltip>
                                    }
                                    </div>
                                    }
                                    
                                </form>
                                </div>
                            </div>
                    </div>
                </nav>
            </div>
        </>
    )

}

